import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import Loading from 'components/Loading';
import useWindowSize from 'hooks/useWindowSize';
import { AppContext } from 'shared/AppContext';
import storage from 'shared/storage';
import NavLayout from '../../layouts/NavLayout';
import NavMobileLayout from '../../layouts/NavMobileLayout';

const AdminRoute = ({ component: Component, backgroundColor, ...rest }) => {
  const [width] = useWindowSize();

  const {
    state: { accountId },
  } = useContext(AppContext);

  return (
    <Route
      {...rest}
      render={(props) => {
        const user = storage.get('user', {});
        // const capability = storage.get('capability', {});

        if (typeof user.role !== 'undefined') {
          if (user.role !== 'track' && rest.path !== '/admin-track/stripe')
            return (
              <Redirect
                to={{
                  pathname: '/admin',
                  state: { from: props.location },
                }}
              />
            );
        } else {
          return (
            <Redirect
              to={{
                pathname: '/',
                state: { from: props.location },
              }}
            />
          );
        }

        // if (props?.location?.pathname?.includes('/admin-track/guest-lists')) {
        //   if (!capability?.guests)
        //     return (
        //       <Redirect
        //         to={{
        //           pathname: '/',
        //           state: { from: props.location },
        //           accessDenied: true,
        //         }}
        //       />
        //     );
        // }

        return (
          <div>
            {width <= 860 ? (
              <NavMobileLayout backgroundColor={backgroundColor}>
                {accountId ? <Component {...props} /> : <Loading />}
              </NavMobileLayout>
            ) : (
              <NavLayout>
                {accountId ? <Component {...props} /> : <Loading />}
              </NavLayout>
            )}
          </div>
        );
      }}
    />
  );
};

export default AdminRoute;
